import React from 'react'
import { AuthConsumer } from 'react-check-auth'
import { Route, Redirect } from 'react-router-dom'

// MBQ OCT 2025 RESTYLING
import { useFeature } from '../contexts/Feature/FeatureContext'
import _ from 'lodash'
import LinkToNewApp from '../components/Links/LinkToNewApp'
import UX_TYPE from '../globals/uxType'

const NoAuthRoute = ({ component: Component, ...rest }) => {
  // MBQ OCT 2025 RESTYLING
  const mainUxOldApp = _.get(useFeature(), 'mainUxOldApp')

  return (
    <AuthConsumer>
      {({ userInfo }) => (
        userInfo ?          
          (
            userInfo.uxPreference === UX_TYPE.OLD_APP ?
            (
              <Redirect to={{ pathname: '/', state: { referrer: window.location.href } }} />
            )
            :
            (
              <LinkToNewApp />
            )            
          )
          :
          (
            mainUxOldApp ?
            (
              <Route {...rest} render={props => <Component {...props} />} />
            )
            :
            <LinkToNewApp />            
          )        
      )}
    </AuthConsumer>
  )
}  

export default NoAuthRoute